import { AuthorizationParams, useAuth0 } from "@auth0/auth0-react";
import Fallback from "../Fallback";
import TopBar from "../TopBar";
import { Button } from "@mui/material";
import { messages } from "./consts";

/**
 * Renders a screen for users who have encountered a problem logging in
 * Error codes should be available in url
 * https://auth0.com/docs/libraries/common-auth0-library-authentication-errors
 *
 * A `prompt` is the specific screen you want to show
 * https://auth0.com/docs/customize/login-pages/universal-login/customize-signup-and-login-prompts#terminology
 *
 *
 */

export default function AuthError() {
  const { error, isLoading, loginWithRedirect } = useAuth0();

  if (isLoading) {
    return null;
  }
  let title = "Something went wrong";
  let message = error.message;
  let prompt: AuthorizationParams["prompt"] = "login";
  let cta = "Sign in";

  const messageKeys = Object.keys(messages);
  for (let i = 0; i < messageKeys.length; i++) {
    const strategy = messages[messageKeys[i]](error);

    if (strategy.isError) {
      title = strategy.title;
      message = strategy.message;
      prompt = strategy.prompt;
      cta = strategy.cta;
      break;
    }
  }

  return (
    <>
      <TopBar />
      <Fallback
        title={title}
        message={<span>{message}</span>}
        actions={
          <Button
            color="primary"
            variant="contained"
            onClick={() =>
              loginWithRedirect({
                authorizationParams: {
                  prompt,
                },
              })
            }
          >
            {cta}
          </Button>
        }
      />
    </>
  );
}
